import React, { useContext } from "react";

import DataContext from "../../../../../../context/DataContext";
import AccordionShell from "../../../../../global/AccordionShell";

import OrgChart from "./OrgChart";
import PermissionsManager from "./PermissionsManager";

export default function OrgPermissions({
  userInfo,
  trigger,
  setTrigger,
  myAccount,
  profile,
  managedLocations,
}) {
  const { userRoles } = useContext(DataContext);
  return (
    <div className="mt-6 h-fit rounded-sm bg-white p-4 shadow-lg xl:mr-6">
      <h2 className="mb-2 text-[1.2rem] font-bold">Permissions and Org Structure</h2>
      <div className="ml-2">
        {userRoles.permissions.includes("users.view_permissionset") ? (
          <AccordionShell title="Permissions">
            <PermissionsManager
              userInfo={userInfo}
              trigger={trigger}
              setTrigger={setTrigger}
              myAccount={myAccount}
            />
          </AccordionShell>
        ) : (
          ""
        )}
        {userRoles.permissions.includes("users.view_usertocaseassignments") ? (
          <AccordionShell title="Organization">
            <OrgChart
              userInfo={userInfo}
              trigger={trigger}
              setTrigger={setTrigger}
              myAccount={myAccount}
              profile={profile}
              managedLocations={managedLocations}
            />
          </AccordionShell>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
